import { Template, TemplateKey } from '../../types/templates'
import { AppCollectionDataTypes } from '../types'
import { Collection, Collections } from '../types/collection'
import { PracticeAppCollectionDataTypes } from '../types/practiceApp'
import { adminsCollection } from './admins'
import { assessmentsCollection } from './assessments'
import { insurersCollection, medicaidInsurersCollection } from './insurer'
import { invoicesCollection } from './invoices'
import { patientsCollection } from './patients'
import { midwivesCollection } from './practice'
import { dotPhraseTemplatesCollection } from './dotPhrase'
import { revenueCodesCollection } from './revenueCode'
import { supplyKeywordsCollection } from './supply'
import {
  assessmentTemplatesCollection,
  authAppealsTemplatesCollection,
  authInstructionsTemplatesCollection,
  authTemplatesCollection,
  claimTemplatesCollection,
  clinicalsTemplatesCollection,
  consentFormTemplatesCollection,
  invoiceTemplatesCollection,
  practiceContractTemplatesCollection,
} from './templates'

export type AppCollections = Collections<AppCollectionDataTypes>
export type PracticeAppCollections = Collections<PracticeAppCollectionDataTypes>
export const appCollections: AppCollections = {
  assessments: assessmentsCollection,
  practices: midwivesCollection,
  insurers: insurersCollection,
  medicaidInsurers: medicaidInsurersCollection,
  authAppealsTemplates: authAppealsTemplatesCollection,
  authInstructionsTemplates: authInstructionsTemplatesCollection,
  authTemplates: authTemplatesCollection,
  claimTemplates: claimTemplatesCollection,
  consentFormTemplates: consentFormTemplatesCollection,
  clinicalsTemplates: clinicalsTemplatesCollection,
  templates: assessmentTemplatesCollection,
  invoicesReceiptsTemplates: invoiceTemplatesCollection,
  practiceContractTemplates: practiceContractTemplatesCollection,
  admins: adminsCollection,
  dotPhraseTemplates: dotPhraseTemplatesCollection,
  invoices: invoicesCollection,
  patients: patientsCollection,
  revenueCodes: revenueCodesCollection,
  supplyKeywords: supplyKeywordsCollection,
}

export const templateCollections: Record<TemplateKey, Collection<Template>> = {
  assessments: assessmentTemplatesCollection,
  authAppeals: authAppealsTemplatesCollection,
  authInstructions: authInstructionsTemplatesCollection,
  authorizations: authTemplatesCollection,
  claims: claimTemplatesCollection,
  clinicals: clinicalsTemplatesCollection,
  consentForm: consentFormTemplatesCollection,
  invoiceAndReceipt: invoiceTemplatesCollection,
  practiceContract: practiceContractTemplatesCollection,
}

export const practiceAppCollections: PracticeAppCollections = {
  insurers: insurersCollection,
  medicaidInsurers: medicaidInsurersCollection,
}
